import { defineNuxtPlugin } from '#imports'
import textShimmer from './directives/textShimmer'

export default defineNuxtPlugin((nuxtApp) => {
  // Register shared directives used across the UI package
  nuxtApp.vueApp.directive('text-shimmer', textShimmer)
})
